import React from "react";
import { addElement } from "../../../actions/CreateSiteActions/createSiteActions";
import { connect } from "react-redux";
import PeoplePicker from "../../formFields/PeoplePicker";
import { ADD_PMOS } from "../../../actions/types";
import { Icon } from "@fluentui/react";
import { isPMOsValid } from "./Validator";
import InfoTooltip from "../../formFields/InfoTooltip";
import Api from "../../../services/Api";

const warningIcon = (
  <div className="warning-inline warning-nolabel">
    <Icon iconName="Warning" />
  </div>
);

class PMO extends React.Component {
  state = {
    PMOs: [],
  };
  componentDidMount() {
    const { template } = this.props;

    if (!template || !template.config) return;

    const groupId =
      template.id === 5
        ? template.config.pmoUserId
        : template.id === 6
        ? template.adGroupConfiguration.entraID
        : null;

    if (groupId) {
      this.getPMO(groupId, template.id);
    }
  }

  getPMO(groupId, templateId) {
    const isSingleUser = templateId === 5;
    const endpoint = isSingleUser
      ? `/User/GetUserById?userId=${groupId}`
      : `/User/GetUsersByADGroup?adGroupId=${groupId}`;

    Api.get(endpoint).then((res) => {
      if (res.data) {
        const PMOs = isSingleUser
          ? [mapDbUserForPeoplePicker(res.data)]
          : res.data.map(mapDbUserForPeoplePicker);

        this.setState({ PMOs });
        this.props.addPMOs(PMOs);
      }
    });
  }

  _onSelectedUser = (items) => {
    this.props.addPMOs(items);
  };

  _getRoleLabel = () => {
    const { template } = this.props;

    return template && template.id === 5
      ? "PMO"
      : template && template.id === 6
      ? "R&D PMO"
      : "PMO";
  };

  render() {
    const warning =
      this.props.possibleWarning && !isPMOsValid() ? warningIcon : null;

    return (
      <div className="wizard-inside-third" style={{ height: "unset" }}>
        <div className="item-Owner">
          {this._getRoleLabel()}
          <InfoTooltip content="The Project Management Office facilitates the sharing of resources, methodologies, tools and techniques and it is one of the owners of the team created in this provisioning process. This configuration ensures that the information will always be available for our company, even if all people with access to the team (including other owners) leave. HIS OWNERSHIP MUST NEVER BE REMOVED from any channel of the team!" />
        </div>
        {warning}
        <PeoplePicker
          defaultUsers={this.state.PMOs}
          onSelectedUsers={this._onSelectedUser}
          disabled={true}
          //itemLimit={1}
          // errorMessage={error}
        />
      </div>
    );
  }
}

// Approver.propTypes = {
//     addApprover: PropTypes.func.isRequired,
//     approver: PropTypes.object,
//     currentUser: PropTypes.object,
//     manager: PropTypes.object,
//     owner: PropTypes.object,
// }

export const mapDbUserForPeoplePicker = (user) => {
  return {
    id: user.userId,
    displayName: user.displayName,
    email: user.email,
    jobTitle: "",
    givenName: "",
    surName: "",
    manager: null,
    role: user.role,
  };
};

const mapActionToProp = (dispatch) => ({
  addPMOs: (element) => {
    dispatch(addElement(ADD_PMOS, element));
  },
});

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  PMOs: state.newSite.PMOs,
  possibleWarning: state.wizard.nextStepRequested,
  template: state.newSite.Template,
});

export default connect(mapStateToProps, mapActionToProp)(PMO);



// WEBPACK FOOTER //
// ./src/components/CreateSite/Step5/PMO.js